import styled from "styled-components";

export const MobileTimerControllerClockWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const MobileControllerBackgroundBox = styled.div`
  background: #2e2e2e;
  border-radius: 20px;
  width: 100%;
  padding: 20px 10px;
  box-sizing: border-box;

  > .title {
    font-family: Pretendard;
    font-weight: 700;
    font-size: 20px;
    color: #ffffff;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  > .box {
    margin-top: 20px;
    width: 100%;
    height: 64px;
    border-radius: 20px;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 20px;
    line-height: 64px;
    color: #121212;
    text-align: center;
    background: #fff;
  }
`;

export const MobileControllerInputWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
  align-items: center;
  flex: 1;

  > .button {
    background: #3052fb;
    width: 100%;
    height: 64px;
    border-radius: 20px;
    font-family: Pretendard;
    font-weight: 700;
    font-size: 18px;
    line-height: 64px;
    text-align: center;
    color: #fff;
    cursor: pointer;
  }

  > img {
    cursor: pointer;
    width: 34px;
    height: 34px;
  }

  > .level {
    width: 100%;
    height: 34px;
    border-radius: 20px;
    background: #fff;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 16px;
    line-height: 34px;
    color: #121212;
    text-align: center;
  }
`;

export const MobileControllerClockTimeWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const MobileControllerClockTimeWrapperButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;

  > .button {
    cursor: pointer;
    width: 34.26px;
    height: 34.26px;
    border-radius: 50%;
    background: #626262;
    display: flex;
    justify-content: center;
    align-items: center;

    > img {
      width: 7.06px;
      height: auto;
    }
  }

  > .name {
    font-family: Pretendard;
    font-weight: 700;
    font-size: 9.07px;
    text-align: center;
    color: #ffffff;
  }
`;

export const MobileControllerClockTimeButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const MobileControllerClockTimeTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: #fff;
  align-items: center;
  flex: 1;

  > .title {
    font-family: Pretendard;
    font-weight: 700;
    font-size: 18px;
    text-align: center;
  }
  > .time {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 50.38px;
    text-align: center;
  }
`;
